import { render } from "./bookmark.vue?vue&type=template&id=f27f9f44&scoped=true&ts=true"
import script from "./bookmark.vue?vue&type=script&setup=true&lang=ts"
export * from "./bookmark.vue?vue&type=script&setup=true&lang=ts"

import "./bookmark.vue?vue&type=style&index=0&id=f27f9f44&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27f9f44"],['__file',"src/views/browse-view/components/bookmark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f27f9f44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f27f9f44', __exports__)) {
    console.log('reload')
    api.reload('f27f9f44', __exports__)
  }
  
  module.hot.accept("./bookmark.vue?vue&type=template&id=f27f9f44&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('f27f9f44', render)
  })

}


export default __exports__